export default String.raw`
.validation-popup {
    width: 768px;
    max-width: 768px;
    min-height: 320px;
    max-height: 872px;

    .dialog {
        &__header {
            gap: 16px;

            &-title {
                margin-right: auto;
            }
        }

        &__content {
            padding: 24px 32px 0 32px;

            .products {
                &__list {
                    width: 100%;

                    &-item {
                        width: 100%;

                        .product__name {
                            font-weight: 500;
                        }

                        p {
                            display: inline-flex;
                            margin-right: 8px;
                        }
                    }
                }
            }
        }

        &__actions {
            width: 100%;
            padding: 16px 32px 32px 32px;
            justify-content: center;
        }
    }
}
`